import { CustomTheme } from 'config/themes/types';
import React from 'react';
import { StyleSheetManager, ThemeProvider } from 'styled-components';

// Central app theme provider. Historically this also hosted a global `StyleSheetManager`
// `shouldForwardProp` safety net (via `@emotion/is-prop-valid`) to emulate styled-components v5's
// automatic prop filtering during the v6 upgrade. That net was removed once every styling prop on a
// DOM element was migrated to the `$`-transient convention (see UPGRADE.md / TRANSIENT_PROPS_BACKLOG.md),
// so it is no longer needed — v6 now correctly keeps `$`-props off the DOM by itself.
// `enableVendorPrefixes` restores v5's automatic vendor prefixing, which v6 turned off by default.
// Without it, properties like `user-select` and `backdrop-filter` (written unprefixed throughout
// the codebase) silently break on Safari < 18.x, which still needs the `-webkit-` variants.
interface AppThemeProviderProps {
  theme: CustomTheme;
  children: React.ReactNode;
}

const AppThemeProvider = ({ theme, children }: AppThemeProviderProps) => (
  <StyleSheetManager enableVendorPrefixes>
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </StyleSheetManager>
);

export default AppThemeProvider;
